<template>
<div id="applogin" v-cloak>

    <b-container>
        <b-row class="my-3">
            <b-col sm="12">
                <b-alert show variant="secondary">
                    {{this.message}}
                </b-alert>
            </b-col>
        </b-row>

    </b-container>
</div>
</template>

<script>

import {
    NAMESPACE
} from '../config.js'

export default {
    name: 'applogin',
    data: function () {         

        return {
            login: {
                utente: this.$route.params.utente,
                token: this.$route.params.token,
                page: this.$route.params.page,
                paramb64: this.$route.params.paramb64 || '',
            },
            message: 'Caricamento in corso...',
        };
    },
    created: function () {

        

        this.axios.post(NAMESPACE + 'rest/logintoken', this.login, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
        .then(response => {
            // JSON responses are automatically parsed.
            try {

                if (!response.data.error) {

                    var res = response.data.message;
                    var token = res.token; 

                    localStorage.setItem('token', token);
                    localStorage.setItem('account', res.account);
                    localStorage.setItem('nome', res.nome);
                    localStorage.setItem('cognome', res.cognome);
                    localStorage.setItem('email', res.email);
                    localStorage.setItem('idsocio', res.id);
                    localStorage.setItem('vismenu', res.vismenu);
                    localStorage.setItem('viscategoria', res.viscategoria);

                    //per distinguere quelli che aprono le pagine da app
                    localStorage.setItem('appname', res.appname);
                    localStorage.setItem('loginfromapp', "S");
                    localStorage.setItem('coloreutenticral', res.coloreutenticral);
                    localStorage.setItem('urlprivacypolicycral', res.urlprivacypolicycral);

                    // if(this.login.page == "rimborsolibri"){
                    //     if(this.login.paramb64 == ''){
                    //         throw new Error("Parametri mancanti!");
                    //     }
                    //     var obj = JSON.parse(atob(this.login.paramb64));                        
                    //     this.$router.replace('/ute/rimborsolibri/id_evento/' + obj.id_evento);
                    // }
                    // else{
                    //     this.$router.replace('/pagenotfound');
                    // }

                    this.$router.replace('/pagenotfound');

                } else {
                    throw new Error(response.data.message);
                }

            } catch (e) {
                this.message = 'Errore: ' + e.message;
                alert('Errore: ' + e.message);
            }

        })
        .catch(e => {
            this.message = 'Errore: ' + (typeof e.response === 'undefined' ? 'Errore interno API' : (e.response.data.message instanceof Object ? 'Errore interno API' : e.response.data.message));
            alert('Errore: ' + (typeof e.response === 'undefined' ? 'Errore interno API' : (e.response.data.message instanceof Object ? 'Errore interno API' : e.response.data.message)) );
        });
          
    }
}

</script>
